import { render, staticRenderFns } from "./deliverGoodsRecord.vue?vue&type=template&id=789bb7c9&scoped=true&"
import script from "./deliverGoodsRecord.vue?vue&type=script&lang=js&"
export * from "./deliverGoodsRecord.vue?vue&type=script&lang=js&"
import style0 from "./deliverGoodsRecord.vue?vue&type=style&index=0&id=789bb7c9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789bb7c9",
  null
  
)

export default component.exports